import * as React from 'react'
import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  EditButton,
  TopToolbar,
  ListButton,
  ReferenceField,
  useRecordContext,
  useGetMany
} from 'react-admin'
import { Typography, Box, Chip } from '@mui/material'
import { Link } from 'react-router-dom'

const ProviderLocationShowActions = () => (
  <TopToolbar>
    <ListButton />
    <EditButton />
  </TopToolbar>
)

const ProviderChips = ({ providerIds }) => {
  const { data: providers, isLoading } = useGetMany(
    'providers',
    { ids: providerIds || [] },
    { enabled: !!providerIds && providerIds.length > 0 }
  )

  if (!providerIds || providerIds.length === 0) {
    return <Typography variant="body2" color="text.secondary">No providers assigned</Typography>
  }
  if (isLoading) return <Typography variant="body2">Loading...</Typography>

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {(providers || []).map(provider => (
        <Chip
          key={provider.id}
          label={provider.displayName}
          component={Link}
          to={`/providers/${provider.id}/show`}
          clickable
          size="small"
          variant="outlined"
          sx={{ textDecoration: 'none' }}
        />
      ))}
    </Box>
  )
}

const ProvidersField = () => {
  const record = useRecordContext();
  return <ProviderChips providerIds={record?.providerIds} />
}

const ProviderLocationDetails = (props) => {
  return (
    <Show actions={<ProviderLocationShowActions />} {...props}>
      <SimpleShowLayout spacing={2} className="details-page-layout">
        <TextField source="id" label="Location ID" />
        <TextField source="locationName" label="Location Name" />
        <TextField source="shopifyLocation" label="Shopify Location" />
        <ReferenceField source="providerGroupId" reference="provider-groups" label="Provider Group" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ProvidersField label="Associated Providers" />
        <DateField source="createdAt" label="Created At" showTime />
      </SimpleShowLayout>
    </Show>
  )
}

export default ProviderLocationDetails
